module.exports = __webpack_public_path__ + "static/media/sdg_icon_3.fdac2f4d.png";